module.exports = __webpack_public_path__ + "img/imgfemale.4911dac6.svg";